import { render } from "./collapsable.vue?vue&type=template&id=4dab3008"
import script from "./collapsable.vue?vue&type=script&lang=js"
export * from "./collapsable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__